/**
 * gzip ArrayBuffer → UTF-8 string
 */
export async function gunzipToString(arrayBuffer) {
  if (typeof DecompressionStream === 'undefined') {
    throw new Error('DecompressionStream is not supported in this browser');
  }
  const ds = new DecompressionStream('gzip');
  const stream = new Response(arrayBuffer).body.pipeThrough(ds);
  return await new Response(stream).text();
}

function looksLikeGzip(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  return bytes.length >= 2 && bytes[0] === 0x1f && bytes[1] === 0x8b;
}

/**
 * Response body → JSON
 * - GCS가 Content-Encoding: gzip 이면 fetch가 이미 풀어 줄 수 있음 → 매직바이트로 판단
 * - meta.contentEncoding 만 믿지 않음 (이중 gunzip 방지)
 */
export async function decodeJsonMaybeGzip(res, contentEncoding) {
  const buf = await res.arrayBuffer();

  if (looksLikeGzip(buf)) {
    const text = await gunzipToString(buf);
    return JSON.parse(text);
  }

  const asText = new TextDecoder().decode(buf);
  try {
    return JSON.parse(asText);
  } catch (parseError) {
    if (contentEncoding === 'gzip') {
      try {
        const text = await gunzipToString(buf);
        return JSON.parse(text);
      } catch (gzipError) {
        console.error('[gunzip] meta said gzip but body is neither gzip nor JSON', {
          parseError,
          gzipError,
        });
        throw parseError;
      }
    }
    throw parseError;
  }
}
